import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, FileText, AlertTriangle } from "lucide-react";

const FLOW = [
  { code: "GST Data",       desc: "Spend records"   },
  { code: "HSN Codes",      desc: "Sector mapping"  },
  { code: "Carbon Factors", desc: "MRIO database"   },
  { code: "Green Score",    desc: "0–100 index"     },
  { code: "Risk Tier",      desc: "Classification"  },
];

const BADGES = [
  { icon: <ShieldCheck size={12} />, text: "GHG Protocol Scope 3" },
  { icon: <FileText size={12} />,    text: "PCAF Compatible"       },
  { icon: <ShieldCheck size={12} />, text: "No Primary Data Needed" },
];

export default function HeroSection() {
  return (
    <section className="hero-section" id="hero">
      <div className="hero-grid-overlay" aria-hidden="true" />
      <div className="hero-radial" aria-hidden="true" />

      <div className="landing-container hero-inner">
        {/* Eyebrow */}
        <div className="hero-eyebrow">
          <span className="hero-eyebrow-pulse" />
          India's first GST-native carbon risk screening platform
        </div>

        {/* Headline */}
        <h1 className="hero-headline">
          Carbon Risk Screening<br />
          <span className="hero-headline-accent">from Your GST Data</span>
        </h1>

        {/* Sub */}
        <p className="hero-sub">
          Estimate and classify your organisation's carbon exposure using a spend-based
          methodology aligned with GHG Protocol Scope&nbsp;3 guidance and PCAF standards.
          No primary emissions data required.
        </p>

        {/* Methodology badges */}
        <div className="hero-badges">
          {BADGES.map((b, i) => (
            <span key={i} className="hero-badge">
              {b.icon}
              {b.text}
            </span>
          ))}
        </div>

        {/* CTAs */}
        <div className="hero-cta-group">
          <Link to="/login" className="hero-cta-primary">
            Start Screening
            <ArrowRight size={16} />
          </Link>
          <a
            href="/greensetu_methodology_v1.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-cta-secondary"
          >
            <FileText size={15} />
            View Methodology
          </a>
        </div>

        {/* Constraint disclaimer */}
        <div className="hero-disclaimer">
          <AlertTriangle size={13} />
          GreenSetu outputs are <strong>screening estimates only</strong> — not verified GHG inventories
          and not ISO&nbsp;14064 compliant reporting.
        </div>

        {/* Flow strip */}
        <div className="hero-flow-strip">
          <div className="hero-flow-label">SCREENING PIPELINE</div>
          <div className="hero-flow-nodes">
            {FLOW.map((step, i) => (
              <React.Fragment key={i}>
                <div className="hero-flow-node">
                  <div className="hero-flow-node-code">{step.code}</div>
                  <div className="hero-flow-node-desc">{step.desc}</div>
                </div>
                {i < FLOW.length - 1 && (
                  <div className="hero-flow-arrow" aria-hidden="true">›</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
